import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar8 from '../components/navbar8';
import Footer4 from '../components/footer4';
import BlogPage from '../components/blog-page';
import BlogPostList from '../components/BlogPostList'; 
import VideoGallery from '../components/VideoGallery';
import './blog.css';

const Blog = () => {
  return (
    <div className="blog-container">
      <Helmet>
        <title>CAIC: Media & News</title>
        <meta property="og:title" content="CAIC: Media & News" />
      </Helmet>
      <Navbar8 />
      <VideoGallery />
      <BlogPage />
      <BlogPostList /> 
      <Footer4 />
    </div>
  );
}

export default Blog;



